// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"773232a9","213":"a9052ba1"}[chunkId] + ".chunk.js";
};